import type { MerchantPreferredLanguage } from "@unbox/db";

export const SUPPORTED_RISK_EXPLANATION_LANGUAGES: {
  code: MerchantPreferredLanguage;
  name: string;
  english?: string;
}[] = [
  { code: "en", name: "English" },
  { code: "de", name: "Deutsch", english: "German" },
  { code: "fr", name: "Français", english: "French" },
  { code: "es", name: "Español", english: "Spanish" },
  { code: "th", name: "ไทย", english: "Thai" },
  { code: "vi", name: "Tiếng Việt", english: "Vietnamese" },
  { code: "id", name: "Bahasa Indonesia", english: "Indonesian" },
  { code: "ms", name: "Bahasa Melayu", english: "Malay" },
  { code: "zh", name: "中文", english: "Mandarin" },
  { code: "tl", name: "Tagalog" },
];
